import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import PrivateRoute from './components/VerificaSessao/VerificaSessao';
import LoginWrapper from './components/Login/LoginWrapper';
import Home from './components/main/main';
import MobileHome from './components/mobile/Pagina-Principal/main'
import { useMediaQuery } from 'react-responsive';
// Importe seus outros componentes aqui

function App() {

  const isMobile = useMediaQuery({
    query: "(max-width: 767px)"
  });

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/login" element={<LoginWrapper />} />
        <Route path="/home" element={
          <PrivateRoute>
           {isMobile ? <MobileHome /> : <Home />}
          </PrivateRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;
